import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center font-bold" }, "修改群名", -1)
const _hoisted_2 = { class: "bg-gray-1 px-5 pt-1.5 rounded-md" }
const _hoisted_3 = { class: "text-xs text-subtle" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "加密群名", -1)
const _hoisted_5 = { class: "float-right" }
const _hoisted_6 = { class: "bg-gray-1 px-5 pt-1.5 rounded-md mb-2.5" }
const _hoisted_7 = { class: "text-xs text-subtle" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "公开群名", -1)
const _hoisted_9 = { class: "float-right" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "pl-5 text-sm text-primary" }, "加密群名仅群成员可见", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 修改 ")

import { ref } from 'vue'
import { Notify, useDialogPluginComponent } from 'quasar'
import { ChatGroup } from '@/types/user-chat-group'
import { useChatGroupStore } from '@/store/user-chat-group'


export default /*#__PURE__*/_defineComponent({
  props: {
    groupInfo: null
  },
  emits: [...useDialogPluginComponent.emits],
  setup(__props: any) {

const props = __props as {
    groupInfo: ChatGroup
}





const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const chatGroupStore = useChatGroupStore()
const encryptedName = ref(props.groupInfo.name)
const publicName = ref(props.groupInfo.publicName)

async function modifyGroupName() {
    try {
        await chatGroupStore.updateGroupName(
            props.groupInfo.host,
            props.groupInfo.id,
            // 如果 name 未修改, 则传空字符串, 否则加密后的字符串会不同, 导致发送通知
            encryptedName.value === props.groupInfo.name ? '' : encryptedName.value,
            publicName.value
        )
        onDialogOK()
    } catch (error) {
        Notify.create(error instanceof Error ? error.message : (error as string))
    }
}

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_base_btn = _resolveComponent("base-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide),
    class: "q-dialog__transparent_backdrop"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin py-7" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "pb-7" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "pb-2.5" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("span", _hoisted_5, _toDisplayString(encryptedName.value.length) + "/20", 1)
                ]),
                _createVNode(_component_q_input, {
                  modelValue: encryptedName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((encryptedName).value = $event)),
                  borderless: "",
                  class: "py-2",
                  "input-class": "placeholder-gray-500 py-0",
                  maxlength: "20",
                  dense: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "pb-7.5" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(publicName.value.length) + "/20", 1)
                ]),
                _createVNode(_component_q_input, {
                  modelValue: publicName.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((publicName).value = $event)),
                  borderless: "",
                  class: "py-2",
                  "input-class": "placeholder-gray-500 py-0",
                  maxlength: "20",
                  dense: ""
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "mx-5 px-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_btn, {
                onClick: _unref(onDialogCancel),
                class: "flex-grow mr-4 h-10",
                outline: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_base_btn, {
                onClick: modifyGroupName,
                disable: !encryptedName.value || !publicName.value,
                class: "flex-grow h-10"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["disable"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})